export default Object.freeze({
  Continue: 'continue',
  ThrowError: 'throw-error',
});
